// extracted by mini-css-extract-plugin
var _1 = "TestFeedbackElement_demo__7389e";
var _2 = "TestFeedbackElement_icon__c4281";
var _3 = "TestFeedbackElement_mobile__325fb";
var _4 = "TestFeedbackElement_root__27c81";
var _5 = "TestFeedbackElement_wrapper__9e455";
export { _1 as "demo", _2 as "icon", _3 as "mobile", _4 as "root", _5 as "wrapper" }
